import { TagDetailsFormGzDataProvider } from '../dataProvider/TagDetailsFormGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';

export class TagDetailsFormDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, TagDetailsFormGzDataProvider);
  }
}
